
import {
  endorsementMapActions,
  endorsementMapMutations
} from "@/store/modules/endorsements";
import { endorsementsDefault } from "@/helpers/endorsementsDefault";
import FormBuilder from "@/components/FormBuilder/FormBuilder.vue";
import { removeEmptyFields } from "../../../helpers/removeEmptyFields";
import VueWithMixins from "@/helpers/mixins";
import EndorsementMixin from "./EndorsementMixin";

export default VueWithMixins(EndorsementMixin).extend({
  components: { FormBuilder },
  name: "CreateEndorsement",
  created() {
    this.SET_EDIT(endorsementsDefault({}));
  },
  methods: {
    ...endorsementMapActions(["createEndorsement"]),
    ...endorsementMapActions(["getAllEndorsements"]),
    ...endorsementMapMutations(["SET_EDIT"]),
    onToolbarItemClick(event: string) {
      switch (event) {
        case "create":
          this.submit();
          break;
        case "cancel":
          this.cancelCallback();
          break;
      }
    },
    async submit(): Promise<void> {
      try {
        if (this.formIsValid) {
          const fieldData = this.editing;
          await this.createEndorsement(
            removeEmptyFields(fieldData as any)
          ).then(() => {
            this.successMessage = "Endorsement created successfully";
            this.$router.replace("/admin/endorsements").catch(() => {});
          });
        } else {
          this.errorMessage = "Please Fill All Required Fields.";
        }
      } catch (err) {
        this.errorMessage = err.message;
        this.$bugSnagClient.notify(err);
      }
    }
  }
});
